import { MutationResult, useMutation } from '@apollo/client';

import {
  RefreshTimelineEntryMutation,
  RefreshTimelineEntryMutationVariables,
} from '../../../types/__generated__';
import refreshTimelineEntry from './queries/refreshTimelineEntry.gql';

export function useRefreshTimelineEntry(): [Function, MutationResult] {
  const [mutation, mutationResult] = useMutation<
    RefreshTimelineEntryMutation,
    RefreshTimelineEntryMutationVariables
  >(refreshTimelineEntry, {
    context: {
      credentials: 'include',
    },
    errorPolicy: 'all',
  });

  const runMutation = async (id: string) => {
    await mutation({ variables: { input: { id } } });
  };

  return [runMutation, mutationResult];
}
